// extracted by mini-css-extract-plugin
export default {"card":"sacopLicitacaoList_card__9kgri"};